module.exports = __webpack_public_path__ + "img/SServ.edae2cd1.svg";